import { consulta } from "./consulta.model";

export class ConsultaPrint {
    consulta: consulta = new consulta;
    print?: boolean = false;
}